import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { toast, Toaster } from 'react-hot-toast';

import { LoginProps, OtpProps } from '@project/types';
import { decodedToken, userAuthService } from '@project/services';
import { Button, FormContainer, OtpForm } from '@project/components';
import { useAppDispatch } from '@project/reducers/store';
import { setUserRole } from '@project/reducers/userRole-reducer/userRole.actions';
import { useRoleRedirect } from '@project/hooks';

export const OtpScreen: FC = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const dispatch = useAppDispatch();
  const phoneNumber = queryParams.get('PhoneNumber');
  const history = useHistory();
  const redirectByRole = useRoleRedirect();

  const onSubmit = async (formData: OtpProps) => {
    if (!formData.email) return userAuthService.confirmOtp(formData);

    await userAuthService.confirmOtp(formData);

    const loginData: LoginProps = {
      username: formData.email,
      password: formData.password,
      remember: false,
    };

    return userAuthService.login(loginData);
  };

  const onSuccess = async () => {
    toast.success('Successfully Reset Password');
    const role = decodedToken.getRole();
    await dispatch(setUserRole(role));
    redirectByRole(role);
  };

  const onBack = () => {
    history.push('/forgot-password-otp');
  };

  const initialValues: OtpProps = {
    phoneNumber: phoneNumber ?? '',
    otp: '',
    confirmPassword: '',
    password: '',
  };

  return (
    <FormContainer>
      <Toaster position="top-center" />
      <div className="flex flex-col">
        <OtpForm initialValues={initialValues} submitForm={onSubmit} onSuccess={onSuccess} />
        <Button onClick={onBack} type="text" className="font-bold -ml-1">
          Back
        </Button>
      </div>
    </FormContainer>
  );
};
